<a class="tile" [routerLink]="link">

    <div class="icon">

        <img *ngIf="icon" [src]="icon">
    </div>
    <div class="spacer"></div>
    <p class="text">{{text}}</p>
</a>
